import store from "../../store/store"
import { SharedKnowledgeBaseHub } from "../hubs/sharedKnowledgeBase"

export const sharedKnowledgeBaseHub = new SharedKnowledgeBaseHub(store)
